import { ActionType, createStandardAction } from 'typesafe-actions';

import {
  EntitlementsSearchRequest,
  GenericError,
  GetPendingUserMarketDataEntitlementsResponsePayload,
} from '@tradingblock/types';
import { buildGenericRequestReceiveActions } from '../../actionUtilities';
import { AdminIdRequest } from '.';

const ADMIN_REQUEST_ENTITLEMENT_UPDATES = '@admin/entitlements/search/data/REQUEST';
const ADMIN_RECEIVE_ENTITLEMENT_UPDATES = '@admin/entitlements/search/data/RECEIVE';
const ADMIN_ERROR_ENTITLEMENT_UPDATES = '@admin/entitlements/search/data/ERROR';

const ADMIN_ENTITLEMENTS_SET_PAGE = '@admin/entitlements/search/ui/SET_PAGE';
const ADMIN_ENTITLEMENTS_SET_PAGE_SIZE = '@admin/entitlements/search/ui/SET_PAGE_SIZE';

const ADMIN_ENTITLEMENTS_SET_SELECTED_ENTITLEMENT_ID = '@admin/entitlements/search/detail/SET_SELECTED_ENTITLEMENT_ID';
const ADMIN_ENTITLEMENTS_CLEAR_SELECTED_ENTITLEMENT_ID =
  '@admin/entitlements/search/detail/CLEAR_SELECTED_ENTITLEMENT_ID';

const ADMIN_ENTITLEMENTS_REFRESH_ENTITLEMENTS = '@admin/entitlements/search/data/REFRESH';

const [
  requestEntitlementUpdates,
  receiveEntitlementUpdates,
  errorEntitlementUpdates,
] = buildGenericRequestReceiveActions({
  REQUEST: ADMIN_REQUEST_ENTITLEMENT_UPDATES,
  RECEIVE: ADMIN_RECEIVE_ENTITLEMENT_UPDATES,
  ERROR: ADMIN_ERROR_ENTITLEMENT_UPDATES,
})<
  EntitlementsSearchRequest & { blockId: string },
  { response: GetPendingUserMarketDataEntitlementsResponsePayload; blockId: string },
  GenericError<any, AdminIdRequest> & { blockId: string }
>();

export const AdminEntitlementsSearchActions = {
  requestEntitlementUpdates,
  receiveEntitlementUpdates,
  errorEntitlementUpdates,
  setEntitlementsPage: createStandardAction(ADMIN_ENTITLEMENTS_SET_PAGE)<
    Pick<EntitlementsSearchRequest, 'page'> & { blockId: string }
  >(),
  setEntitlementsPageSize: createStandardAction(ADMIN_ENTITLEMENTS_SET_PAGE_SIZE)<
    Pick<EntitlementsSearchRequest, 'pageSize'> & { blockId: string }
  >(),
  setSelectedEntitlementId: createStandardAction(ADMIN_ENTITLEMENTS_SET_SELECTED_ENTITLEMENT_ID)<{
    blockId: string;
    entitlementId: number;
  }>(),
  clearSelectedEntitlementId: createStandardAction(ADMIN_ENTITLEMENTS_CLEAR_SELECTED_ENTITLEMENT_ID)<{
    blockId: string;
  }>(),
  refreshEntitlements: createStandardAction(ADMIN_ENTITLEMENTS_REFRESH_ENTITLEMENTS)<
    EntitlementsSearchRequest & { blockId: string }
  >(),
};

export const AdminEntitlementsActions = {
  ...AdminEntitlementsSearchActions,
};

export type AdminEntitlementsAction = ActionType<typeof AdminEntitlementsActions>;
